<template>
  <v-toolbar class="container grey darken-2 footer">

    <v-toolbar-title class="white--text body-2">{{$t('message.supportNumberMsg')}}</v-toolbar-title>

    <v-spacer></v-spacer>
    <v-btn class="btn-primary" v-if="showPrevious()" @click="prevTab">{{
      $t('message.previous')
    }}</v-btn>
    <v-btn class="btn-primary" v-if="showNext()" @click="nextTab">{{
      $t('message.next')
    }}</v-btn>
  </v-toolbar>
</template>

<script>
import { EventBus } from '../main.js'

export default {
  data: () => ({}),
  methods: {
    showPrevious() {
      return this.$parent.currentTab > 0
    },
    showNext() {
      return this.$parent.currentTab < this.$parent.getTabCnt() - 1
    },
    nextTab() {
      EventBus.$emit('onNextTab')
    },
    prevTab() {
      EventBus.$emit('onPrevTab')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue